(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    // 2026-06-15: reveal the confirmation modal after a successful contact submit.
  // Shopify appends ?contact_posted=true to the URL on success (including after
  // the hCaptcha spam-challenge round-trip), which is more reliable than the
  // server-side flash. The param is set only on real success -> no false positive.
  (function () {
    function showIfPosted() {
      var params = new URLSearchParams(window.location.search);
      if (params.get('contact_posted') !== 'true') return;
      var modal = document.getElementById('ContactFormSuccess');
      if (!modal) return;
      modal.classList.add('is-visible');
      if (typeof modal.focus === 'function') modal.focus();
      // strip the param so a refresh doesn't re-show the modal
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showIfPosted);
    } else {
      showIfPosted();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
